import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap ring-1 ring-inset [&_svg]:size-3',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-sunken text-ink-soft ring-line',
        brand: 'bg-brand-50 text-brand-700 ring-brand-200/70',
        success: 'bg-success-50 text-success-700 ring-success-500/20',
        warning: 'bg-warning-50 text-warning-700 ring-warning-500/25',
        danger: 'bg-danger-50 text-danger-700 ring-danger-500/20',
        info: 'bg-info-50 text-info-700 ring-info-500/20',
      },
      size: { sm: 'px-2 py-0.5 text-2xs', md: 'px-2.5 py-0.5 text-xs' },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  },
)
